import posthog from 'posthog-js';

const VIEWED_CTAS = new Set();
let observer = null;

function getCtaProps(el) {
    const cta = el.closest('[data-cta-id]');
    if (!cta) return null;
    return {
        cta_id: cta.dataset.ctaId,
        destination: cta.dataset.ctaDestination || 'other',
        audience: cta.dataset.ctaAudience || 'both',
        page_type: cta.dataset.ctaPageType || detectPageType(),
    };
}

function detectPageType() {
    const path = window.location.pathname;
    if (path === '/') return 'home';
    if (/^\/(sign-up|parent-sign-up)/.test(path)) return 'signup';
    if (/^\/(uabmedicine|wellthy|vivvi|cariloop|tdi|trial|credit)/.test(path)) return 'landing';
    if (/-jobs(\/|$)/.test(path)) return 'seo_jobs';
    if (/^\/search-/.test(path)) return 'seo_search';
    return 'content';
}

/**
 * Observe all [data-cta-id] elements for 50% visibility.
 * Fires CTA Viewed once per cta_id per page view.
 */
function observeCtaViewed() {
    if (observer) return;
    observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                if (!entry.isIntersecting) continue;
                if (!entry.target.checkVisibility({ opacityProperty: true, visibilityProperty: true })) continue;
                observer.unobserve(entry.target);
                const props = getCtaProps(entry.target);
                if (!props || VIEWED_CTAS.has(props.cta_id)) continue;
                VIEWED_CTAS.add(props.cta_id);
                posthog.capture('CTA Viewed', props);
            }
        },
        { threshold: 0.5 },
    );

    document.querySelectorAll('[data-cta-id]').forEach((el) => observer.observe(el));
}

/**
 * Delegated click listener for [data-cta-id] elements.
 * Uses sendBeacon transport so the event isn't lost on navigation.
 */
function listenCtaClicked() {
    document.addEventListener('click', (e) => {
        const cta = e.target.closest('[data-cta-id]');
        if (!cta) return;
        const props = getCtaProps(cta);
        if (!props) return;
        posthog.capture('CTA Clicked', props, { transport: 'sendBeacon' });
    });
}

/**
 * Initialize CTA tracking. Call after PostHog is initialized.
 */
export function initCtaTracking() {
    if (typeof posthog.capture !== 'function') return;
    observeCtaViewed();
    listenCtaClicked();
}
